import { render, staticRenderFns } from "./PatientGenderCard.vue?vue&type=template&id=64cf6f5e&scoped=true&"
import script from "./PatientGenderCard.vue?vue&type=script&lang=ts&"
export * from "./PatientGenderCard.vue?vue&type=script&lang=ts&"
import style0 from "./PatientGenderCard.vue?vue&type=style&index=0&id=64cf6f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../common/temp/node_modules/.pnpm/vue-loader@15.9.8_679359cdb69c218f2f8f476b2ba08796/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64cf6f5e",
  null
  
)

export default component.exports